import {
  TXN_OVERVIEW,
  SET_TXN_OVERVIEW,
  FETCH_TRANSACTIONS,
  SET_TRANSACTION_DETAILS,
  RESET,
  SET_VEHICLE_DETAIL,
} from './constants';

export const fetchTxnOverview = (payload: { id: string; fromTime?: string; toTime?: string; txnType?: string }) => {
  const { id, fromTime = '', toTime = '', txnType = '' } = payload;
  return {
    type: TXN_OVERVIEW,
    id,
    fromTime,
    toTime,
    txnType,
  };
};

export const setTxnOverview = (data: any) => ({
  type: SET_TXN_OVERVIEW,
  data,
});

export const fetchTransactions = (payload: {
  pageNo: string;
  pageSize: number;
  transactionType: string;
  vehicleId: string;
  reset: boolean;
  fromTime: string;
  toTime: string;
  vehicleNumber?: string;
}) => {
  const { pageNo, pageSize = 20, transactionType, vehicleId, fromTime, toTime, vehicleNumber, reset = false } = payload;
  const requestParam: any = {};
  const params = [];
  if (pageNo) {
    params.push(`pageNo=${pageNo}`);
  }
  if (transactionType) {
    params.push(`transactionType=${transactionType}`);
  }
  if (fromTime) {
    params.push(`fromTime=${fromTime}`);
  }
  if (fromTime) {
    params.push(`toTime=${toTime}`);
  }
  params.push(`pageSize=${pageSize}`);
  requestParam.param = vehicleId;
  requestParam.vNum = vehicleNumber;
  requestParam.query = params.join('&');
  requestParam.reset = reset;
  return {
    type: FETCH_TRANSACTIONS,
    data: requestParam,
  };
};

export const setTxnDetails = (data: any) => ({
  type: SET_TRANSACTION_DETAILS,
  data,
});

export const resetDetails = () => ({
  type: RESET,
});

export const setVehicleDetail = (data: any) => ({
  type: SET_VEHICLE_DETAIL,
  data,
});
